module.exports = __webpack_public_path__ + "static/img/1.fd64ddc1.jpg";